// react
import React from 'react';

// third-party
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import HomePage from './home/HomePage';

// application
import Footer from './footer';
import Header from './header';
import MobileMenu from './mobile/MobileMenu';

import catalogos from '../data/catalogos';
import Catalogo from './shared/Catalogos';
import { _path } from '../data/headerNavigation';
import MobileHeader from './mobile/MobileHeader';
import PrivateRoute from './header/PrivateRouter';
import Entes from './shared/Entes';
import FichaCliente from '../views/clients/FichaCliente';
import Appointment from '../views/appoinment';
import Providers from '../views/providers';
import Users from '../views/users';
import Clients from '../views/clients';
import Templates from '../views/notifications';
import Roles from '../views/roles';
import Resources from '../views/resources';
import ToroidalContacts from '../views/toroidalContacts';
import ItemTypes from '../views/itemTypes/ItemTypes';
import Activities from '../views/activities/Activities';
import ItemProviders from '../views/itemsProviders/ItemProviders';
import Bills from '../views/bills';
import SMSList from '../views/sms';
import Quotes from '../views/bills/Quotes';
import Receipt from '../views/receipts';
import AppConfig from '../views/appConfig/AppConfig';
import BillsOfDay from '../reports/bills/BillsOfDay';
import BillsByClient from '../reports/bills/BillsByClient';
import BillsByMonth from '../reports/bills/BillsByMonth';
import BillsByDate from '../reports/bills/BillsByDate';
import BillxC from '../views/bills/BillxC';
import BillsByDays from '../reports/bills/BillsByDays';
import MasterCatalogs from '../views/masterCatalogs';
import LentesOftalmicos from '../views/items/LentesOftalmicos';
import LentesDeContacto from '../views/items/LentesDeContacto';
import MarcoAro from '../views/items/MarcoAro';
import Servicios from '../views/items/Servicios';
import Accesorios from '../views/items/Accesorios';

import initProduct from '../views/movimientos/initProducts/initProduct';
import initPurchases from '../views/movimientos/initProducts/initPurchases';
import OutPutProducts from '../views/movimientos/outPutProducts';

import initAdjustments from '../views/movimientos/initProducts/initAdjustments';

import Rates from '../views/rates/Rates';
import CorrectionContacts from '../views/correctionContacts';
import PartialLogin from './account/partialLogin';
import useTimer from '../hooks/useTimer';
import NavigationList from './slide/NavigationList';
import NuevoNotify from '../views/bills/NuevoNotify';
import BillsExpired from './bill/BillsExpired';
import Reports from '../views/reports/Reports';
import LentesEsclerales from '../views/items/LentesEsclerales';
import SMSCredits from '../views/sms/SMSCredits';
import Stock from '../reports/bills/Stock';
import Sclerales from '../views/items/Sclerales';
import ScleralsConfig from '../views/sclerals/ScleralsConfig';
import Kardex from '../views/reports/kadex/Kardex';



function Layout(props) {
    const { match, headerLayout } = props;
     const { active } = useTimer();

    const PrintCatalogos = catalogos.map(c => {
        return  <PrivateRoute key={c.name} exact path={`${_path[String(headerLayout).toUpperCase()]}/${c.name}`} render={(props) => (
                    <Catalogo {...props} {...c}/>
        )} />
    });

    const _cp = _path.CLINICA;    

    return (
        <React.Fragment>          

            <ToastContainer autoClose={5000} hideProgressBar />

            <MobileMenu layout={headerLayout}/>
            <PartialLogin /> 
            <NavigationList />
            <NuevoNotify />
            <div className="site">
                <header className="site__header d-lg-none">
                    <MobileHeader />
                </header>

                <header className="site__header d-lg-block d-none">
                    <Header layout={headerLayout} />
                </header>

                <div className="site__body">
                
                    <Switch>
                        <PrivateRoute exact path={`${match.path}`} component={HomePage} />
                        <PrivateRoute exact path={`${_cp}/clientes`} component={Clients} />                         
                        <PrivateRoute exact path={`${_cp}/cliente/:id`} component={FichaCliente} />                         
                        <PrivateRoute exact path={`${_cp}/usuarios`} component={Users} />                         
                        <PrivateRoute exact path={`${_cp}/agenda/doctores`} render={props => <Entes {...props} ente="Doctores" url='doctors' /> } />                         
                        <PrivateRoute exact path={`${_cp}/agenda/vendedores`} render={props => <Entes {...props} ente="Vendedores" url='vendors'/> } />                         
                        <PrivateRoute exact path={`${_cp}/agenda`} component={Appointment} />                         
                        <PrivateRoute exact path={`${_cp}/proveedores`} component={Providers} />                         
                        <PrivateRoute exact path={`${_cp}/plantillas`} component={Templates} />    
                        <PrivateRoute exact path={`${_cp}/roles`} component={Roles} />
                        <PrivateRoute exact path={`${_cp}/recursos`} component={Resources} /> 
                        <PrivateRoute exact path={`${_cp}/contactostoricos`} component={ToroidalContacts} />
                        <PrivateRoute exact path={`${_cp}/contactosesferico`} component={CorrectionContacts} />
                        <PrivateRoute exact path={`${_cp}/scleral-table`} component={ScleralsConfig} />
                        
                        <PrivateRoute exact path={`${_cp}/articulos/lentesOftalmicos`} component={LentesOftalmicos}  />  
                        <PrivateRoute exact path={`${_cp}/articulos/lentesDeContacto`} component={LentesDeContacto} />  
                        <PrivateRoute exact path={`${_cp}/articulos/marco`} component={MarcoAro} />  
                        <PrivateRoute exact path={`${_cp}/articulos/servicio`} component={Servicios} />  
                        <PrivateRoute exact path={`${_cp}/articulos/accesorios`} component={Accesorios} />  
                        <PrivateRoute exact path={`${_cp}/articulos/lentesEsclerales`} component={Sclerales} />  
                   
                        <PrivateRoute exact path={`${_cp}/articulos/tipos`} component={ItemTypes} />                         
                        <PrivateRoute exact path={`${_cp}/actividades`} component={Activities} />                         
                        <PrivateRoute exact path={`${_cp}/articulos/proveedores`} component={ItemProviders} />                        
                        <PrivateRoute exact path={`${_cp}/cotizaciones`} component={Quotes}/>                        
                        <PrivateRoute exact path={`${_cp}/facturas`} component={Bills} />                        
                        <PrivateRoute exact path={`${_cp}/facturascc`} component={BillxC} />                        
                        <PrivateRoute exact path={`${_cp}/sms`} component={SMSList} />                        
                        <PrivateRoute exact path={`${_cp}/sms/credits`} component={SMSCredits} />                        
                        <PrivateRoute exact path={`${_cp}/facturas/recibos`} component={Receipt} />     
                        <PrivateRoute exact path={`${_cp}/app`} component={AppConfig} /> 
                        <PrivateRoute exact path={`${_cp}/catalogos/maestros`} component={MasterCatalogs} />     

                        <PrivateRoute exact path={`${_cp}/reportes/billsOfDay`} component={BillsOfDay} />     
                        <PrivateRoute exact path={`${_cp}/reportes/billsByClient`} component={BillsByClient} />     
                        <PrivateRoute exact path={`${_cp}/reportes/billsByMonth`} component={BillsByMonth} />     
                        <PrivateRoute exact path={`${_cp}/reportes/billsByDays`} component={BillsByDays} />     
                        <PrivateRoute exact path={`${_cp}/reportes/billsByDate`} component={BillsByDate} />  
   
                        <PrivateRoute exact path={`${_cp}/movimientos/salidas`} component={OutPutProducts} />     
                        <PrivateRoute exact path={`${_cp}/movimientos/entradas`} component={initAdjustments} />     
                        <PrivateRoute exact path={`${_cp}/movimientos/inv-inicial`} component={initProduct} />     
                        <PrivateRoute exact path={`${_cp}/movimientos/compras`} component={initPurchases} />     
                        <PrivateRoute exact path={`${_cp}/reports/kardex`} component={Kardex} />     

                        <PrivateRoute exact path={`${_cp}/inventario/stock`} component={Stock} />     
                        <PrivateRoute exact path={`${_cp}/tasa-de-cambio`} component={Rates} />     

                        <PrivateRoute exact path={`${_cp}/bills/expired`} component={BillsExpired} /> 

                        <PrivateRoute exact path={`${_cp}/reportes/clientes/lista`} component={props => <Reports reportName='ClientList' {...props}/>} />     
                        <PrivateRoute exact path={`${_cp}/reportes/clientes/deudores`} component={props => <Reports reportName='ClientMora' {...props}/>} />     
                        <PrivateRoute exact path={`${_cp}/reportes/clientes/poredad`} component={props => <Reports reportName='ClientPorEdad' {...props}/>} />     
                        
                        <PrivateRoute exact path={`${_cp}/reportes/records/lista`} component={props => <Reports reportName='RecordList' {...props}/>} />     
                        <PrivateRoute exact path={`${_cp}/reportes/bill/season`} component={props => <Reports reportName='BillSeason' {...props}/>} />     
                        <PrivateRoute exact path={`${_cp}/reportes/items/lista`} component={props => <Reports reportName='ItemsList' {...props}/>} />     
                        <PrivateRoute exact path={`${_cp}/reportes/items/inventario`} component={props => <Reports reportName='Inventario' {...props}/>} />     

                        <PrivateRoute exact path={`${_cp}/reportes/proveedores`} component={props => <Reports reportName='Proveedores' {...props}/>} /> 
                        <PrivateRoute exact path={`${_cp}/reportes/valoracion-almacen`} component={props => <Reports reportName='Valoracion' {...props}/>} /> 
                        <PrivateRoute exact path={`${_cp}/reportes/cuentasporpagar`} component={props => <Reports reportName='CuentasPorPagar' {...props}/>} /> 
                        <PrivateRoute exact path={`${_cp}/reportes/sales`} component={props => <Reports reportName='VentaMes' {...props}/>} /> 
                        <PrivateRoute exact path={`${_cp}/reportes/stock`} component={props => <Reports reportName='Stock' {...props}/>} /> 

                        {PrintCatalogos}
                    </Switch>
                </div>

                <footer className="site__footer">
                    <Footer />
                </footer>
            </div>
        </React.Fragment>

    )
}

export default Layout;

